export const SET_EMERGENCY_CONTACT_FORM = 'SET_EMERGENCY_CONTACT_FORM'
export const SET_EMERGENCY_CONTACT_FORM_FIELD =
  'SET_EMERGENCY_CONTACT_FORM_FIELD'
